export type User = any; // eslint-disable-line @typescript-eslint/no-explicit-any

export interface AuthState {
  error?: Error;
  isAuthenticated: boolean;
  isLoading: boolean;
  isInitialized: boolean;
  user?: User;
  userSub?: string;
  userInfo?: User;
}

export const initialAuthState: AuthState = {
  isAuthenticated: false,
  isLoading: true,
  isInitialized: false,
};
